var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCreatorBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4655 6.94372L21.1824 0.659191C20.7604 0.237123 20.188 0 19.5912 0C18.9944 0 18.422 0.237123 18 0.659191L0.659543 18.0011C0.235672 18.4216 -0.00189614 18.9945 1.13992e-05 19.5915V25.8761C1.13992e-05 27.1187 1.00737 28.1261 2.25001 28.1261H8.53454C9.13161 28.128 9.70451 27.8904 10.125 27.4665L27.4655 10.1261C27.8875 9.70409 28.1247 9.13172 28.1247 8.53489C28.1247 7.93807 27.8875 7.36569 27.4655 6.94372ZM2.71548 19.1261L14.625 7.21653L16.972 9.56357L5.06251 21.4717L2.71548 19.1261ZM2.25001 21.8415L6.28454 25.8761H2.25001V21.8415ZM9.00001 25.4106L6.65298 23.0636L18.5625 11.154L20.9095 13.5011L9.00001 25.4106ZM22.5 11.9106L16.2155 5.62607L19.5905 2.25107L25.875 8.53419L22.5 11.9106Z",
    fill: "#00067E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCreatorBlue);
export default __webpack_public_path__ + "static/media/content-creator-blue.0d8172b779509041a72244b644a11bb8.svg";
export { ForwardRef as ReactComponent };